export const APP_VERSION = process.env.REACT_APP_VERSION;
export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
export const API_VERSION = process.env.REACT_APP_API_VERSION;
export const API_URL = `${API_BASE_URL}/${API_VERSION}`;
export const ENABLE_REDUX_LOGGER = process.env.REACT_APP_ENABLE_REDUX_LOGGER === 'true';
export const DEFAULT_PERIOD = process.env.REACT_APP_DEFAULT_PERIOD || '';

export const API_BASE_URL_NEXT = process.env.REACT_APP_API_BASE_URL_NEXT;
export const API_VERSION_NEXT = process.env.REACT_APP_API_VERSION_NEXT;
export const API_URL_NEXT = `${API_BASE_URL_NEXT}/${API_VERSION_NEXT}`;

export default {};
